import React from "react";
import "../styles/SummaryBox.css";

const Summarybox = ({ title, children }) => {
  return (
    <div className="summary-box">
      <h3 className="summary-title">{title}</h3>
      <div className="summary-content">{children}</div>
    </div>
  );
};

export default Summarybox;
